<template>
  <v-dialog v-model="dialog" width="1000">
    <v-card>
      <v-card-title class="headline">
        <v-icon>event_note</v-icon>
        Asignar horario especial
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="p-0">
        <v-form :valid="valid" ref="form" @submit.prevent="save()">
          <v-container grid-list-md style="min-width: 100%">
            <v-layout wrap row>
              <v-flex md6 xs12>
                <v-autocomplete
                  class="sinMargen"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  label="Horario Especial"
                  :items="horarios_especiales"
                  item-text="descripcion"
                  item-value="id"
                  v-model="form.id_horario_especial"
                />
              </v-flex>
              <v-flex md6>
                <v-textarea
                  v-if="form.id_horario_especial == '9'"
                  v-model="form.descripcion_horario"
                  class="sinMargen"
                  rows="1"
                  label="Descripción"
                  outline
                  clearable
                  :rules="$validate(['required'])"
                  required
                >
                </v-textarea>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  :rules="$validate(['required'])"
                  required
                  label="Fecha inicio"
                  type="date"
                  v-model="form.fecha_desde"
                  outline
                  class="sinMargen"
                  autofocus
                  clearable
                />
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  :rules="$validate(['required'])"
                  required
                  label="Fecha fin"
                  type="date"
                  class="sinMargen"
                  v-model="form.fecha_hasta"
                  outline
                  clearable
                />
              </v-flex>
              <!-- <v-flex md6 xs12>
                <v-text-field
                  readonly
                  label="Fecha de registro"
                  type="date"
                  v-model="form.fecha_creacion"
                  outline
                  class="sinMargen"
                  autofocus
                />
              </v-flex> -->
              <v-flex md12 xs12>
                <v-radio-group
                  :disabled="ingresos_salidas_dias.length > 0"
                  v-model="tipo_horario"
                  row
                  @change="asignaHorarioLaboralDefecto()"
                  :rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    },
                  ]"
                >
                  <v-radio label="Continuo" :value="1"></v-radio>
                  <v-radio label="Discontinuo" :value="2"></v-radio>
                  <v-radio label="Por turnos" :value="3"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <h2>HORARIOS</h2>

            <v-layout wrap>
              <v-flex md12 xs12>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    color="primary"
                    dark
                    @click="seleccionarTodo()"
                    slot="activator"
                    ><v-icon dark>done</v-icon>
                  </v-btn>
                  <span>Seleccionar todo</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    color="primary"
                    dark
                    icon
                    @click.native.stop="deseleccionarTodo()"
                    slot="activator"
                    ><v-icon dark>cancel</v-icon></v-btn
                  >
                  <span>Deseleccionar todo</span>
                </v-tooltip>
              </v-flex>
              <!-- LISTADO DE DIAS DE LA SEMANA-->
              <div
                class="text-xs-center"
                v-for="dias in this.dias"
                :key="dias.id"
              >
                <v-flex md12 xs12>
                  <v-tooltip bottom>
                    <v-btn
                      v-if="!verifica(dias.id)"
                      icon
                      slot="activator"
                      @click.native="getId(dias.id)"
                      @change="getId(dias.id)"
                    >
                      <v-icon>check_box_outline_blank</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="verifica(dias.id)"
                      icon
                      slot="activator"
                      @click.native="getId(dias.id)"
                      @change="getId(dias.id)"
                    >
                      <v-icon>done</v-icon>
                    </v-btn>
                  </v-tooltip>
                  {{ dias.valor2 }}
                </v-flex>
              </div>
              <div class="pl-3 pr-3" style="min-width: 100%">
                <v-layout wrap row>
                  <v-flex xs6 md3>
                    <!-- primera hora ingreso-->
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Hora ingreso"
                      type="time"
                      v-model="form.hora_ingreso1"
                    />
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Tolerancia ingreso"
                      type="time"
                      v-model="form.tolerancia1"
                    />
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango inicial Hora ingreso"
                      type="time"
                      v-model="form.rango_ini1_am"
                    />
                  </v-flex>
                  <!-- @change="()=>{
                        $message.info($moment(form.rango_fin1_am,'HH:mm').format('HH:mm:59'))
                      }" -->

                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango final Hora ingreso"
                      type="time"
                      v-model="form.rango_fin1_am"
                    />
                  </v-flex>
                  <!-- primera hora salida-->
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Hora salida"
                      type="time"
                      v-model="form.hora_fin1"
                    />
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Tolerancia salida"
                      type="time"
                      v-model="form.tolerancia2"
                    />
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango inicial Hora salida"
                      type="time"
                      v-model="form.rango_ini2_am"
                    />
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango final Hora salida"
                      type="time"
                      v-model="form.rango_fin2_am"
                    />
                  </v-flex>
                  <!-- segunda hora ingreso-->
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Hora ingreso"
                      type="time"
                      v-model="form.hora_ingreso2"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Tolerancia ingreso"
                      type="time"
                      v-model="form.tolerancia3"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango inicial Hora ingreso - Tarde"
                      type="time"
                      v-model="form.rango_ini1_pm"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango final Hora ingreso - Tarde"
                      type="time"
                      v-model="form.rango_fin1_pm"
                    />
                  </v-flex>
                  <!--segunda hora salida-->
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Hora salida"
                      type="time"
                      v-model="form.hora_fin2"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Tolerancia salida"
                      type="time"
                      v-model="form.tolerancia4"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango inicial Hora salida - Tarde"
                      type="time"
                      v-model="form.rango_ini2_pm"
                    />
                  </v-flex>
                  <v-flex xs6 md3 v-if="this.tipo_horario == 2">
                    <v-text-field
                      :rules="$validate(['required'])"
                      required
                      label="Rango final Hora salida - Tarde"
                      type="time"
                      v-model="form.rango_fin2_pm"
                    />
                  </v-flex>
                  <!-- Botones adicionar horarios -->
                  <v-flex xs12 md12 v-if="tipo_horario == 3">
                    <v-btn
                      color="success"
                      icon
                      title="Adicionar"
                      @click="verificarHorario(ingresos_salidas)"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    Adicionar turno
                  </v-flex>
                  <v-flex xs12 md12 v-if="tipo_horario != 3">
                    <v-btn
                      color="success"
                      icon
                      title="Adicionar"
                      @click="verificarHorario(ingresos_salidas)"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    Adicionar horario
                  </v-flex>
                  <!-- Tabla de registros de horarios -->
                  <v-flex xs12 md12>
                    <v-data-table
                      :items="ingresos_salidas_dias"
                      class="elevation-1"
                      hide-actions
                      :headers="headers_horario_temporal"
                      :disable-initial-sort="true"
                      no-data-text="No se registro ningun horario"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">
                          {{ props.item.dia }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.hora_inicio }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.hora_fin }}
                        </td>
                        <td class="text-xs-center">
                          <v-btn
                            color="error"
                            icon
                            title="Eliminar"
                            @click.prevent="eliminarHorario(props.item.id)"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </div>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.native="close()">
          <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
          v-if="ingresos_salidas_dias.length > 0"
          color="primary"
          :loading="loading"
          @click.prevent="save()"
        >
          <v-icon dark>save</v-icon> {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  data() {
    return {
      dialog: false,
      loading: false,
      valid: true,
      horario: {},
      selected: [],
      ingresos_salidas: [],
      ingresos_salidas_dias: [],
      tipo_horario: null,
      horarios_especiales: [],
      horarios_laborales: [],
      bandera_tabla_horarios: false,
      id_correlativo: 0,
      correlativo_ficticio: 1,
      correlativo_ficticio_temporal: 0,
      form: {},
      dias: [],
      headers_horario_temporal: [
        { text: "Día", value: "dia", align: "center" },
        { text: "Hora ingreso", value: "hora_ingreso", align: "center" },
        { text: "Hora salida", value: "hora_salida", align: "center" },
      ],
      headers: [
        { text: "Día", value: "id_dia", align: "center" },
        { text: "Hora de inicio", value: "hora_inicio", align: "center" },
        { text: "Hora final", value: "hora_fin", align: "center" },
        { text: "Acciones", value: "", align: "center" },
      ],
      horarios_cargados: [],
      genero: null,
    };
  },
  async mounted() {
    // this.form.hora_ingreso1 = "08:30";
    // this.form.hora_fin1 = "12:30";
    // this.form.hora_ingreso2 = "14:30";
    // this.form.hora_fin2 = "18:30";
    await this.obtenerDias();
    this.$bus.$on("openDialogAsignacionEspecial", async (item) => {
      this.form.fecha_creacion = this.$moment().format("YYYY-MM-DD");
      this.form.fecha_desde = this.$moment().format("YYYY-MM-DD");
      this.form.fecha_hasta = this.$moment().format("YYYY-MM-DD");
      this.form.tolerancia1 = "00:05";
      this.form.tolerancia2 = "00:00";
      this.form.tolerancia3 = "00:05";
      this.form.tolerancia4 = "00:00";
      this.horario = item;
      this.tipo_horario = 1;
      this.horarios_laborales = this.horario.horarios;
      await this.concatenarHorarios();
      await this.asignaHorarioLaboralDefecto();
      this.dialog = true;
      await this.obtieneGeneroServidor();
      await this.obtenerHorariosEspeciales();
    });
  },
  methods: {
    // Verificar genero del servidor
    async obtieneGeneroServidor() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select id_genero FROM persona.persona WHERE id=${parseInt(
                this.horario.id
              )}"){
              respuesta
              }
            }	
          `,
        });
        respuesta = respuesta.runQuery.respuesta[0];
        this.genero = respuesta.id_genero;
      } catch (error) {
        console.log(error);
      }
    },
    asignaHorarioLaboralDefecto() {
      if (this.horario.horarios.length > 0) {
        let copia_list = JSON.stringify(this.horario.horarios);
        copia_list = JSON.parse(copia_list);
        copia_list.sort(function (a, b) {
          if (a.hora_inicio > b.hora_inicio) {
            return 1;
          }
          if (a.hora_inicio < b.hora_inicio) {
            return -1;
          }
          return 0;
        });
        this.form.hora_ingreso1 = copia_list[0].hora_inicio;
        this.form.hora_fin1 =
          this.tipo_horario == 2
            ? copia_list[0].hora_fin
            : copia_list[1]
            ? copia_list[1].hora_fin
            : copia_list[0].hora_fin;
        this.form.hora_ingreso2 = copia_list[1]
          ? copia_list[1].hora_inicio
          : null;
        this.form.hora_fin2 = copia_list[1] ? copia_list[1].hora_fin : null;
      }
    },
    concatenarHorarios() {
      for (let index = 0; index < this.horarios_laborales.length; index++) {
        const element = this.horarios_laborales[index];
        element.detalle = `${element.descripcion} -  ${element.hora_inicio} - ${element.hora_fin}`;
      }
    },
    verifica(id) {
      return this.selected.includes(id);
    },
    eliminarHorario(id_horario) {
      try {
        let copia_horarios_ingresos_salidas_dias = this.ingresos_salidas_dias;
        let copia_horarios_ingresos_salidas_dias2 = [];
        this.$confirm("¿Desea eliminar el registro?", () => {
          for (
            let j = 0;
            j < copia_horarios_ingresos_salidas_dias.length;
            j++
          ) {
            const element = copia_horarios_ingresos_salidas_dias[j];
            if (element.id != id_horario) {
              copia_horarios_ingresos_salidas_dias2.push(element);
            }
          }
        });
        this.ingresos_salidas_dias = copia_horarios_ingresos_salidas_dias2;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.loading = false;
      this.horario = {};
      this.form = {};
      this.ingresos_salidas = [];
      this.selected = [];
      this.ingresos_salidas_dias = [];
      this.horarios_especiales = [];
      (this.horarios_cargados = []), (this.horarios_laborales = []);
      this.dialog = false;
    },
    async verificarHorario(conjunto) {
      try {
        let elemento_horario = {};
        let lista_horarios = [];
        let size_conj = conjunto.length;
        let conj_hora_ingreso;
        let conj_hora_salida;
        let conj_id;
        if (
          !this.form.rango_ini1_am ||
          !this.form.rango_fin1_am ||
          !this.form.rango_ini2_am ||
          !this.form.rango_fin2_am
        ) {
          this.$message.info("Ingrese los rangos de los horarios 1");
          return;
        }
        if (!this.form.tolerancia1 || !this.form.tolerancia2) {
          this.$message.info("Ingrese las tolerancias");
          return;
        }
        if (
          this.tipo_horario == 2 &&
          (!this.form.rango_ini1_pm ||
            !this.form.rango_fin1_pm ||
            !this.form.rango_ini2_pm ||
            !this.form.rango_fin2_pm)
        ) {
          this.$message.info("Ingrese los rangos de los horarios 2");
          return;
        }
        if (
          this.tipo_horario == 2 &&
          (!this.form.tolerancia3 || !this.form.tolerancia4)
        ) {
          this.$message.info("Ingrese la tolerancia");
          return;
        }
        if (!this.form.fecha_desde || !this.form.fecha_hasta) {
          this.$message.info("Ingrese las fechas");
          return;
        }
        if (!this.tipo_horario) {
          this.$message.info("Seleccione el tipo de horario");
          return;
        }
        if (this.selected.length < 1) {
          this.$message.info("Seleccione los dias");
          return;
        }
        if (
          (this.tipo_horario == 1 || this.tipo_horario == 3) &&
          (!this.form.hora_ingreso1 || !this.form.hora_fin1)
        ) {
          this.$message.info("Ingrese las horas");
          return;
        }
        if (
          this.tipo_horario == 2 &&
          (!this.form.hora_ingreso1 ||
            !this.form.hora_fin1 ||
            !this.form.hora_ingreso2 ||
            !this.form.hora_fin2)
        ) {
          this.$message.info("Ingrese las horas");
          return;
        }

        if (
          this.selected.length > 0 &&
          this.form.fecha_desde &&
          this.form.fecha_hasta
        ) {
          //construyo el vector a enviar:
          //CONTINUO
          if (this.tipo_horario == 1) {
            for (let i = 0; i < this.selected.length; i++) {
              const element = this.selected[i];
              //let id_tabla=
              elemento_horario = {
                id_elemento: 1,
                id_dia: element,
                hora_inicio: this.form.hora_ingreso1,
                hora_fin: this.form.hora_fin1,
                rango_ini1_am: this.form.rango_ini1_am,
                rango_ini2_am: this.form.rango_ini2_am,
                rango_fin1_am: this.form.rango_fin1_am,
                rango_fin2_am: this.form.rango_fin2_am,
                tolerancia1: this.form.tolerancia1,
                tolerancia2: this.form.tolerancia2,
              };
              lista_horarios.push(elemento_horario);
            }
          }
          // DISCONTINUO
          if (this.tipo_horario == 2) {
            for (let i = 0; i < this.selected.length; i++) {
              const element = this.selected[i];
              //let id_tabla=
              elemento_horario = {
                id_elemento: 1,
                id_dia: element,
                hora_inicio: this.form.hora_ingreso1,
                hora_fin: this.form.hora_fin1,
                rango_ini1_am: this.form.rango_ini1_am,
                rango_ini2_am: this.form.rango_ini2_am,
                rango_fin1_am: this.form.rango_fin1_am,
                rango_fin2_am: this.form.rango_fin2_am,
                tolerancia1: this.form.tolerancia1,
                tolerancia2: this.form.tolerancia2,
              };
              lista_horarios.push(elemento_horario);
              elemento_horario = {
                id_elemento: 2,
                id_dia: element,
                hora_inicio: this.form.hora_ingreso2,
                hora_fin: this.form.hora_fin2,
                rango_ini1_am: this.form.rango_ini1_pm,
                rango_ini2_am: this.form.rango_ini2_pm,
                rango_fin1_am: this.form.rango_fin1_pm,
                rango_fin2_am: this.form.rango_fin2_pm,
                tolerancia1: this.form.tolerancia3,
                tolerancia2: this.form.tolerancia4,
              };
              lista_horarios.push(elemento_horario);
            }
          }
          // POR TURNOS
          if (this.tipo_horario == 3) {
            for (let i = 0; i < this.selected.length; i++) {
              const element = this.selected[i];
              //let id_tabla=
              elemento_horario = {
                id_elemento: conj_id,
                id_dia: element,
                hora_inicio: this.form.hora_ingreso1,
                hora_fin: this.form.hora_fin1,
                rango_ini1_am: this.form.rango_ini1_am,
                rango_ini2_am: this.form.rango_ini2_am,
                rango_fin1_am: this.form.rango_fin1_am,
                rango_fin2_am: this.form.rango_fin2_am,
                tolerancia1: this.form.tolerancia1,
                tolerancia2: this.form.tolerancia2,
              };
              lista_horarios.push(elemento_horario);
            }
          }
          // Enviar a validacion:
          let rpta = await this.validarHorario(lista_horarios);
          if (rpta != false) {
            //adicionamos al listado:
            for (let v = 0; v < lista_horarios.length; v++) {
              const elemento_ingreso = lista_horarios[v];
              elemento_ingreso.id = this.correlativo_ficticio;
              elemento_ingreso.dia = this.obtenerNombreDia(
                elemento_ingreso.id_dia
              );
              this.ingresos_salidas_dias.push(elemento_ingreso);
              this.correlativo_ficticio++;
            }
            //limpiamos el formulario
            this.selected = [];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async adicionarElementosAVector(valor) {
      try {
        let v_fecha_desde = [];
        let v_fecha_hasta = [];
        let v_dias = [];

        if (this.ingresos_salidas_dias.length > 0) {
          this.ingresos_salidas_dias.forEach((element) => {
            v_fecha_desde.push(element.hora_inicio);
            v_fecha_hasta.push(element.hora_fin);
            v_dias.push(element.id_dia);
          });
        } else {
          v_fecha_desde = [];
          v_fecha_hasta = [];
          v_dias = [];
        }
        if (valor == 1) {
          return v_fecha_desde;
        }
        if (valor == 2) {
          return v_fecha_hasta;
        }
        if (valor == 3) {
          return v_dias;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async validarHorario(item) {
      try {
        let rpta = true;
        let bandera_vector = 1;
        let p_vector_hora_desde = [];
        let p_vector_hora_hasta = [];
        let p_vector_dias = [];
        let p_vector_hora_desde2;
        let p_vector_hora_hasta2;
        let p_vector_dias2 = [];

        if (this.ingresos_salidas_dias.length > 0) {
          //adiciono los elementos ya existentes y aprobados
          p_vector_hora_desde = await this.adicionarElementosAVector(1);
          p_vector_hora_hasta = await this.adicionarElementosAVector(2);
          p_vector_dias = await this.adicionarElementosAVector(3);
        }
        //adiciono los n elementos nuevos a verificar:
        for (let j = 0; j < item.length; j++) {
          const elemento_a_validar = item[j];
          p_vector_hora_desde.push(elemento_a_validar.hora_inicio);
          p_vector_hora_hasta.push(elemento_a_validar.hora_fin);
          p_vector_dias.push(elemento_a_validar.id_dia);
        }

        //convirtiendo en cadena
        p_vector_hora_desde2 = p_vector_hora_desde.toString();
        p_vector_hora_hasta2 = p_vector_hora_hasta.toString();
        p_vector_dias2 = p_vector_dias.toString();

        p_vector_hora_desde2 = "{" + p_vector_hora_desde2 + "}";
        p_vector_hora_hasta2 = "{" + p_vector_hora_hasta2 + "}";
        p_vector_dias2 = "{" + p_vector_dias + "}";
        // ID_PERSONA ==> this.horario.id
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_valida_fechas_horario_especial(${parseInt(
                  this.horario.id
                )},'${this.form.fecha_desde}','${
            this.form.fecha_hasta
          }','${p_vector_dias2}','${p_vector_hora_desde2}','${p_vector_hora_hasta2}')"){
                  respuesta
                }
              }
            `,
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_valida_fechas_horario_especial.split(
            "|"
          );
        if (respuesta[0] == "0") {
          this.$message.warning(respuesta[1]);
          rpta = false;
        }
        return rpta;
      } catch (error) {
        console.log(error);
      }
    },
    getId(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }

      return sw;
    },
    deseleccionarTodo() {
      this.selected = [];
    },
    seleccionarTodo() {
      let lista_seleccion = [];
      lista_seleccion = this.dias;
      for (let index = 0; index < this.dias.length; index++) {
        const element = this.dias[index];
        let sw = false;
        for (let i = 0; i < this.selected.length; i++) {
          const element2 = this.selected[i];
          if (parseInt(element.id) == element2) {
            sw = true;
            break;
          }
        }
        if (!sw) {
          this.selected.push(element.id);
        }
      }
    },
    async obtenerHorariosEspeciales() {
      try {
        let res = await this.$service.graphql({
          query: `
          query{
							runQuery(consulta:"SELECT * FROM control.horario h where h.jornada ='E' and h.id_estado=1"){
								respuesta
							}
							}
          `,
        });
        this.horarios_especiales = res.runQuery.respuesta;
        if (this.genero != 1) {
          let vec_aux = [];
          this.horarios_especiales.forEach((element) => {
            if (element.id != 6) {
              vec_aux.push(element);
            }
          });
          this.horarios_especiales = vec_aux;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerDias() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              params(tipo:"dia"){
                rows{
                  id
                  valor
                }
              }
            }
          `,
        });
        //this.dias = res.params.rows
        let dias_parametrica = res.params.rows;
        dias_parametrica.sort(function (a, b) {
          if (a.valor.split("-")[0] > b.valor.split("-")[0]) {
            return 1;
          }
          if (a.valor.split("-")[0] < b.valor.split("-")[0]) {
            return -1;
          }
          return 0;
        });
        dias_parametrica.forEach((element) => {
          if (element.id == 7) {
            element.valor2 = "Lunes";
            element.marcado = false;
            this.dias.push(element);
          }
          if (element.id == 8) {
            element.valor2 = "Martes";
            element.marcado = false;
            this.dias.push(element);
          }
          if (element.id == 9) {
            element.valor2 = "Miercoles";
            element.marcado = false;
            this.dias.push(element);
          }
          if (element.id == 10) {
            element.valor2 = "Jueves";
            element.marcado = false;
            this.dias.push(element);
          }
          if (element.id == 11) {
            element.valor2 = "Viernes";
            element.marcado = false;
            this.dias.push(element);
          }
          /////// ASIGNADO POR WAGNER COARITE
          if (element.id == 12) {
            element.valor2 = "Sabado";
            element.marcado = false;
            this.dias.push(element);
          }
          if (element.id == 6) {
            element.valor2 = "Domingo";
            element.marcado = false;
            this.dias.push(element);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    obtieneIdHorarioLaboral(id) {
      const found = this.horario.horario_personas.find(
        (element) => element.id_horario == parseInt(id)
      );
      return parseInt(found.id);
    },
    eliminarItem(id) {
      let horarios_aux = [];
      for (let index = 0; index < this.horarios_cargados.length; index++) {
        const element = this.horarios_cargados[index];
        if (element.id != id) {
          horarios_aux.push(element);
        }
      }
      this.horarios_cargados = horarios_aux;
    },
    adicionarHorarioEspecial() {
      if (this.$refs.form.validate()) {
        let id_horario_laboral = this.obtieneIdHorarioLaboral(
          this.form.id_horario_laboral
        );
        const data = {
          id: this.id_correlativo,
          id_horario_persona: id_horario_laboral,
          hora_inicio: this.form.hora_inicio,
          hora_fin: this.form.hora_fin,
          id_estado: 1,
          id_parametro_dia_valor: this.obtenerNombreDia(
            this.form.id_parametro_dia
          ),
          id_parametro_dia: this.form.id_parametro_dia,
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_hasta,
          id_horario_especial: this.form.id_horario_especial,
        };
        this.horarios_cargados.push(data);
        this.id_correlativo += 1;
        //limpiando campos
        //  this.form.hora_inicio=null
        //   this.form.hora_fin= null
        //   this.form.id_parametro_dia=null
        //   this.form.fecha_desde=null
        //   this.form.fecha_hasta=null
        //   this.form.id_horario_especial=null
      }
    },
    obtenerNombreDia(id) {
      try {
        const descripcion = this.dias.find((fruta) => fruta.id == id).valor2;
        return descripcion;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.ingresos_salidas_dias.length <= 0) {
        this.$message.info("No registro ningun horario");
        return;
      }
      this.loading = true;
      let user = this.$storage.get("user");
      try {
        let correlativo;
        for (let j = 0; j < this.ingresos_salidas_dias.length; j++) {
          const element = this.ingresos_salidas_dias[j];
          if (j == 0) {
            correlativo = await this.$service.graphql({
              query: `
                  query{
                          runQuery(consulta:"select control.fn_obtiene_siguiente_grupo_horario_especial()"){
                            respuesta
                          }
                        }
                      `,
            });
            correlativo =
              correlativo.runQuery.respuesta[0]
                .fn_obtiene_siguiente_grupo_horario_especial;
          }
          this.form.descripcion_horario = this.form.descripcion_horario
            ? this.form.descripcion_horario
            : "";
          //guardamos el grupo de

          let respuesta = await this.$service.graphql({
            query: `
                query{
                        runQuery(consulta:"select control.fn_registra_horario_especial(${parseInt(
                          this.horario.id
                        )},${this.form.id_horario_especial},'${
              this.form.fecha_desde
            }','${this.form.fecha_hasta}',${this.tipo_horario},${
              element.id_dia
            },'${element.hora_inicio}','${element.hora_fin}','${
              this.form.descripcion_horario
            }',${user.id},${parseInt(correlativo)},'${
              element.rango_ini1_am
            }','${this.$moment(element.rango_fin1_am, "HH:mm").format(
              "HH:mm:59"
            )}','${element.rango_ini2_am}','${this.$moment(
              element.rango_fin2_am,
              "HH:mm"
            ).format("HH:mm:59")}','${element.tolerancia1}','${element.tolerancia2}')"){
                          respuesta
                        }
                      }
            `,
          });
        }
        this.$message.success();
        this.close();

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.sinMargen {
  display: block !important;
  padding: 0em 0em 0em 0em !important;
  margin: 0em 0em 0em 0em !important;
  width: 100% !important;
  border-radius: 0 !important;
  line-height: 1 !important;
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/AsignarHorarioEspecial.vue